import { createFileRoute } from "@tanstack/react-router";
import { MfeLoader } from "../../mfe/MfeLoader";

export const Route = createFileRoute("/nhi-olcm/")({
  component: NhiOlcmPage,
});

function NhiOlcmPage() {
  return <MfeLoader name="nhi-olcm" />;
}
